export default "0fa3fe1779b2ab46.png"